export const reloadNotificationAction = {
    START_RELOAD: 'START_RELOAD',
    STOP_RELOAD: 'STOP_RELOAD',
  }